import { Box, Paper, Stack, Text, Title } from '@mantine/core';
import TenantApiKeysManager from './TenantApiKeysManager';

export default function DevToolsPage() {
  return (
    <Box p="md">
      <Stack gap="lg">
        <Box>
          <Title order={3}>Dev tools</Title>
          <Text size="sm" c="dimmed">
            Developer tools for your organisation.
          </Text>
        </Box>

        <Paper withBorder radius="md" p="md">
          <Stack gap="md">
            <Text size="sm" c="dimmed">
              Manage external API keys for your organisation. Keys authenticate requests to the
              external API and are shown only once at the time of generation.
            </Text>
            <TenantApiKeysManager />
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
}
